module.exports = __webpack_public_path__ + "img/2015.fc94b248.png";